import io from "socket.io-client";
import axios from "axios";
//axios.defaults.headers.post['cache-control'] = 'max-age=0'

import geobuf from 'geobuf';
const Pbf = require('pbf');

const socket = process.env.NODE_ENV === 'production' ?
  io.connect(process.env.REACT_APP_DOMAIN, { transports: ['websocket'] }) :
  io.connect('http://localhost:5000/', { transports: ['websocket'] })
// Auth

export async function login(user, pass) {
  const response = await fetch('/api/login', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ "user": user, "password": pass })
  });
  return response
};

export async function logout() {
  const response = await fetch('/api/logout');
  return response
};

export async function getUser() {
  const response = await fetch('/api/getuser');
  return response.json()
};

export async function getUserAgency() {
  const response = await fetch('/api/getuseragency');
  return response.json()
};

export async function getUserGroup() {
  const response = await fetch('/api/getusergroup');
  return response.json()
};

// Fonctions realtime

export function getLiveData(cb) {
  socket.open()
  socket.on('refresh data', data => cb(null, data))
  socket.emit('subscribeToTimer', 20000);
}

export function getLiveDataHook(cb) {
  socket.open();
  socket.on('refresh data', (data) => cb(null, data));
  socket.emit('subscribeToTimer', 20000);

  // Return a cleanup function to disconnect the socket when the component unmounts
  return () => {
    socket.close();
    socket.removeAllListeners('refresh data');
    socket.emit('leave');
  };
}


export async function leave() {
  socket.emit('leave');
  socket.removeAllListeners('refresh data');
  socket.close();
}


// Données pour live routes
// Traces
export async function getTracesRoutes(optc) {

  let result = await axios.post(
    '/api/tracesroutes',
    {
      "optc": optc
    },
    //{ responseType: 'arraybuffer' }
  )

  //const traces = geobuf.decode(new Pbf(result.data));
  const traces = result.data
  return traces

}

// Stops
export async function getTracesStops(optc) {
  const response = await fetch('/api/tracesstops', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ "optc": optc })
  });
  return response.json()
};



// Données pour trip click

export async function getTraces(optc, trip, route) {

  let result = await axios.post(
    '/api/traces',
    {
      "optc": optc,
      "trip": trip
    },
    { responseType: 'arraybuffer' }
  )

  const traces = geobuf.decode(new Pbf(result.data));
  return traces

}

export async function getStops(optc, trip) {

  let result = await axios.post(
    '/api/stops',
    {
      "optc": optc,
      "trip": trip
    },
    { responseType: 'arraybuffer' }
  )

  const stops = geobuf.decode(new Pbf(result.data));
  return stops

}


export async function getAllAgencies() {
  const response = await fetch('/api/getallagencies')
  return response.json()
}

export async function getAgencies() {
  const response = await fetch('/api/getrtagencies')
  return response.json()
}

export async function getGroups() {
  const response = await fetch('/api/getrtgroups')
  return response.json()
}



// Données pour graphiques

export async function getHistory(day, previous) {
  const response = await fetch('/api/allvehicles', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ "date": day, "previous": previous })
  });
  return response.json()
};

export async function curveSingle(day, agency, previous) {
  const response = await fetch('/api/curvesingle', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      "date": day,
      "agency": agency,
      "previous": previous
    })
  });
  return response.json()
};

// Données pour heatmap

export async function getHistoryXY(day, hour) {
  const response = await fetch('/api/allvehiclesXY', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ "date": day, "heure": hour })
  });
  return response.json()
};


// Secteurs pour carte Chloropleth
export async function getAllSecteurs() {
  const response = await fetch('/api/getsecteurs')
  return response.json()
};


// Données ponctualité (stops)
export async function getPonctualiteStopRTL(route, service_id, direction_id) {
  const response = await fetch('/api/getponctualitestop_rtl', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ "route": route, "service_id": service_id, "direction": direction_id })
  });
  return response.json()
};

// Données ponctualité (trips)

export async function getPonctualiteTrips(agency, route, service_id, direction_id, startdate, enddate) {
  const response = await fetch('/api/getponctualitetrip', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      "agency": agency,
      "route": route,
      "service_id": service_id,
      "direction": direction_id,
      "startdate": startdate,
      "enddate": enddate
    })
  });
  return response.json()
};

export async function getPonctualite1Trip(agency, trip_id, startdate, enddate) {
  const response = await fetch('/api/getponctualite1trip', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ "agency": agency, "trip_id": trip_id, "startdate": startdate, "enddate": enddate })
  });
  return response.json()
};

export async function getRoutes(agency) {
  const response = await fetch('/api/getroutes', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ "agency": agency })
  });
  return response.json()
};


export async function getPonctualiteRoutes(op, service_id, startFormat, endFormat) {
  const response = await fetch('/api/getponctualiteroutes', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      "agency": op,
      "service_id": service_id,
      "start": startFormat,
      "end": endFormat
    })
  });
  return response.json()
};


export async function getPonctualiteDay(op, service_id) {
  const response = await fetch('/api/getponctualiteday', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ "agency": op, "service_id": service_id })
  });
  return response.json()
};


export async function getVehicleDaysD3(agency, kpi, kpiname, startdate, enddate) {
  const response = await fetch('/api/getvehdaysD3', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      "agency": agency,
      "kpi": kpi,
      "kpiname": kpiname,
      "startdate": startdate,
      "enddate": enddate
    })
  });
  return response.json()
};


export async function getDailyVehicleWork(agency, startdate, enddate, previous) {
  const response = await fetch('/api/getdailyvehwork', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      "agency": agency,
      "startdate": startdate,
      "enddate": enddate,
      "previous": previous
    })
  });
  return response.json()
};

export async function getDailySingleVehWork(agency, startdate, vehicle, previous) {
  const response = await fetch('/api/getdailysinglevehwork', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      "agency": agency,
      "startdate": startdate,
      "vehicle": vehicle,
      "previous": previous
    })
  });
  return response.json()
};


export async function getSumMonthBenchmarks(agencies, service, period) {
  const response = await fetch('/api/summonthbenchmarks', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      'agencies': agencies,
      'service': service,
      'period': period
    })
  });
  return response.json()
}

export async function getAvgMonthBenchmarks(service, period) {
  const response = await fetch('/api/avgmonthbenchmarks', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      'service': service,
      'period': period
    })
  });
  return response.json()
}

export async function getSumWeekBenchmarks(agencies, service, period) {
  const response = await fetch('/api/sumweekbenchmarks', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      'agencies': agencies,
      'service': service,
      'period': period
    })
  });
  return response.json()
}

export async function getAvgWeekBenchmarks(service, period) {
  const response = await fetch('/api/avgweekbenchmarks', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      'service': service,
      'period': period
    })
  });
  return response.json()
}

export async function getSumDayBenchmarks(agencies, service, period) {
  const response = await fetch('/api/sumdaybenchmarks', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      'agencies': agencies,
      'service': service,
      'period': period
    })
  });
  return response.json()
}

export async function getAvgDayBenchmarks(service, period) {
  const response = await fetch('/api/avgdaybenchmarks', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      'service': service,
      'period': period
    })
  });
  return response.json()
}


export async function getBenchmarks(startInterval, endInterval, dateType) {
  const response = await fetch('/api/getbenchmarks', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      "startInterval": startInterval,
      "endInterval": endInterval,
      "dateType": dateType
    })
  });
  return response.json()
};

export async function getBenchmarksCompare(agency, startInterval, endInterval, dateType) {
  const response = await fetch('/api/getbenchmarkscompare', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      "agency": agency,
      "startInterval": startInterval,
      "endInterval": endInterval,
      "dateType": dateType
    })
  });
  return response.json()
};

export async function getVehNormalizedBenchmarks(startInterval, endInterval, dateType) {
  const response = await fetch('/api/getvehnormbenchmarks', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ "startInterval": startInterval, "endInterval": endInterval, "dateType": dateType })
  });
  return response.json()
};

export async function getLastWeekBenchmarks(agency, service) {
  const response = await fetch('/api/getlastweekbenchmarks', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ "agency": agency, "service": service })
  });
  return response.json()
};

export async function getLastYearBenchmarks(agency, service) {
  const response = await fetch('/api/getlastyearbenchmarks', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ "agency": agency, "service": service })
  });
  return response.json()
};

export async function getGeoData(country) {
  const response = await fetch('/api/getgeodata', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ "country": country })
  });
  return response.json()
};

export async function getChargeJour(op, service_id) {
  const response = await fetch('/api/getchargeday', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ "agency": op, "service_id": service_id })
  });
  return response.json()
};

export async function getChargeRoutes(op, service_id, startFormat, endFormat) {
  const response = await fetch('/api/getchargeroute', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      "agency": op,
      "service_id": service_id,
      "start": startFormat,
      "end": endFormat
    })
  });
  return response.json()
};

export async function getProfilChargeCarte(agency, trip_id) {
  const response = await fetch('/api/getprofilchargecarte', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ 'agency': agency, 'trip_id': trip_id })
  });
  return response.json()
}

export async function getChargeTrips(agency, route, service, direction, startdate, enddate) {
  const response = await fetch('/api/getchargetrips', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      "agency": agency,
      "route": route,
      "service": service,
      "direction": direction,
      "startdate": startdate,
      "enddate": enddate
    })
  });
  return response.json()
};

export async function getProfilChargeGraph(agency, trip_id) {
  const response = await fetch('/api/getprofilchargegraph', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ 'agency': agency, 'trip_id': trip_id })
  });
  return response.json()
}

export async function getCalendarDate(date) {
  const response = await fetch('/api/getcalendardate', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ 'date': date })
  });
  return response.json()
}

export async function getDateFromParams(year, month, week, day) {
  const response = await fetch('/api/datefromparams', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ 'year': year, 'month': month, 'week': week, 'day': day })
  });
  return response.json()
}

export async function getGlobalSumMonthTrends(agency, service, period) {
  const response = await fetch('/api/globalsummonthtrends', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      'agency': agency,
      'service': service,
      'period': period
    })
  });
  return response.json()
}

export async function getDetailedSumMonthTrends(agency, routes, service, period) {
  const response = await fetch('/api/detailedsummonthtrends', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      'agency': agency,
      'routes': routes,
      'service': service,
      'period': period
    })
  });
  return response.json()
}

export async function getAvgMonthTrends(agency, service, period) {
  const response = await fetch('/api/avgmonthtrends', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      'agency': agency,
      'service': service,
      'period': period
    })
  });
  return response.json()
}


export async function getGlobalSumWeekTrends(agency, service, period) {
  const response = await fetch('/api/globalsumweektrends', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      'agency': agency,
      'service': service,
      'period': period
    })
  });
  return response.json()
}


export async function getDetailedSumWeekTrends(agency, routes, service, period) {
  const response = await fetch('/api/detailedsumweektrends', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      'agency': agency,
      'routes': routes,
      'service': service,
      'period': period
    })
  });
  return response.json()
}

export async function getAvgWeekTrends(agency, service, period) {
  const response = await fetch('/api/avgweektrends', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      'agency': agency,
      'service': service,
      'period': period
    })
  });
  return response.json()
}

export async function getGlobalSumDayTrends(agency, service, period) {
  const response = await fetch('/api/globalsumdaytrends', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      'agency': agency,
      'service': service,
      'period': period
    })
  });
  return response.json()
}

export async function getDetailedSumDayTrends(agency, routes, service, period) {
  const response = await fetch('/api/detailedsumdaytrends', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      'agency': agency,
      'routes': routes,
      'service': service,
      'period': period
    })
  });
  return response.json()
}

export async function getAvgDayTrends(agency, service, period) {
  const response = await fetch('/api/avgdaytrends', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      'agency': agency,
      'service': service,
      'period': period
    })
  });
  return response.json()
}


export async function getRouteOperation(agency, startdate, enddate, previous) {
  const response = await fetch('/api/routeoperation', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      'agency': agency,
      'startdate': startdate,
      'enddate': enddate,
      'previous': previous
    })
  });
  return response.json()
}

export async function getRouteOperationHome(agency, startdate, enddate, previous) {
  const response = await fetch('/api/routeoperationhome', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      'agency': agency,
      'startdate': startdate,
      'enddate': enddate,
      'previous': previous
    })
  });
  return response.json()
}

export async function getRouteOperationNonPlani(agency, startdate, enddate, previous) {
  const response = await fetch('/api/routeoperation_nonplani', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      'agency': agency,
      'startdate': startdate,
      'enddate': enddate,
      'previous': previous
    })
  });
  return response.json()
}

export async function getLongRouteTrace(agency, route) {
  const response = await fetch('/api/longroutetrace', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ 'optc': agency, 'route': route })
  });
  return response.json()
}

export async function getLongRouteStops(agency, route) {
  const response = await fetch('/api/longroutestops', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ 'optc': agency, 'route': route })
  });
  return response.json()
}

export async function getPlannedTrips(agency, startDate) {
  const response = await fetch('/api/plantrips', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      'agency': agency,
      'startDate': startDate
    })
  });
  return response.json()
}


export async function getPlannedKms(agency, startDate) {
  const response = await fetch('/api/plankms', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      'agency': agency,
      'startDate': startDate
    })
  });
  return response.json()
}

export async function getPlannedHours(agency, startDate) {
  const response = await fetch('/api/planhours', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      'agency': agency,
      'startDate': startDate
    })
  });
  return response.json()
}

export async function getValuesPrevious(agency, startdate, endformat, home) {
  const response = await fetch('/api/valuesprevious', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      'agency': agency,
      "startdate": startdate,
      "enddate": endformat,
      "home": home
    })
  });
  return response.json()
}

export async function getValuesYesterday(agency, startdate, endformat, home) {
  const response = await fetch('/api/valuesyesterday', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      'agency': agency,
      "startdate": startdate,
      "enddate": endformat,
      "home": home
    })
  });
  return response.json()
}

export async function getCurveStats(date) {
  const response = await fetch('/api/getcurvestats', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ "date": date })
  });
  return response.json()
}

export async function getTripsInfo(agency, date, route) {
  const response = await fetch('/api/gettripsinfo', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ "agency": agency, "date": date, "route": route })
  });
  return response.json()
}


export async function getTripsInfoNonPlani(agency, date, route) {
  const response = await fetch('/api/gettripsinfo_nonplani', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ "agency": agency, "date": date, "route": route })
  });
  return response.json()
}

export async function getTripTrace(agency, date, trip) {
  const response = await fetch('/api/gettriptrace', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ "agency": agency, "date": date, 'trip_id': trip })
  });
  return response.json()
}

export async function getTripPoints(agency, date, trip) {
  const response = await fetch('/api/gettrippoints', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ "agency": agency, "date": date, 'trip_id': trip })
  });
  return response.json()
}

export async function getPlanTrips(agency) {
  const response = await fetch('/api/getplantripssecond', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ "optc": agency })
  });
  return response.json()
}

export async function getGlobalStats(agency, startDate, endDate) {
  const response = await fetch('/api/getglobalstats', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      "agency": agency,
      "startDate": startDate,
      "endDate": endDate
    })
  });
  return response.json()
}

export async function updatePassword(agency, user, password) {
  const response = await fetch('/api/updatepassword', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      "agency": agency,
      "user": user,
      "pass": password
    })
  });
  return response.json()
}


export async function getPlanTripCumul(agency) {
  const response = await fetch('/api/getplantripcumul', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      "agency": agency,
    })
  });
  return response.json()
}


export async function getLatest(agency) {
  const response = await fetch('/api/vehicles', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      "agency": agency,
    })
  });
  return response.json()
}

export async function getLatestVehRoutes(agency) {
  const response = await fetch('/api/vehroutes', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      "agency": agency,
    })
  });
  return response.json()
}

export async function getGlobalCompare(agency, startDate, endDate, service, period) {
  const response = await fetch('/api/getglobalcompare', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      "agency": agency,
      "startDate": startDate,
      "endDate": endDate,
      "service": service,
      "period": period
    })
  });
  return response.json()
}

export async function getDetailedCompare(agency, startDate, endDate, service, period, routes, t) {
  const response = await fetch('/api/getdetailedcompare', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      "agency": agency,
      "startDate": startDate,
      "endDate": endDate,
      "service": service,
      "period": period,
      "routes": routes,
      "t":t
    })
  });
  return response.json()
}

export async function getVehAndOcc(agency) {
  const response = await fetch('/api/getvehandocc', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      "agency": agency,
    })
  });
  return response.json()
}

export async function getDataReport(agency, params, agg, period, dataType, service, routes, startDate, endDate) {
  const response = await fetch('/api/getdatareport', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      "agency": agency,
      "params": params,
      "service": service,
      "period": period,
      "routes": routes,
      "startDate": startDate,
      "endDate": endDate,
      "dataType": dataType,
      "agg": agg
    })
  });
  return response.json()
}